// extracted by mini-css-extract-plugin
export default {"layoutSwitch":"SearchNavigation_layoutSwitch__pjpsI","paginationSwitch":"SearchNavigation_paginationSwitch__2PKDi"};